var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
import { MemberDialogState } from "@/app/uistore/MemberDialogStore";
export class FilterStore {
    constructor() {
        this.open = false;
        this.afterDate = null;
        this.beforeDate = null;
        this.filteractive = false;
        this.groupids = new Set();
        this.contains = "";
        this.memberdialogstate = new MemberDialogState();
        makeObservable(this);
    }
    setContains(cont) {
        this.contains = cont;
    }
    setOpen(open) {
        this.open = open;
    }
    setAferDate(date) {
        this.afterDate = date;
    }
    setBeforeDate(date) {
        this.beforeDate = date;
    }
    setFilterActive(active) {
        this.filteractive = active;
    }
    setSelGroupids(ids) {
        this.groupids.clear();
        ids.forEach((id) => this.groupids.add(id));
    }
    reset() {
        this.afterDate = null;
        this.beforeDate = null;
        this.filteractive = false;
        this.groupids.clear();
        this.contains = "";
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], FilterStore.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FilterStore.prototype, "afterDate", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FilterStore.prototype, "beforeDate", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FilterStore.prototype, "filteractive", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], FilterStore.prototype, "groupids", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], FilterStore.prototype, "contains", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], FilterStore.prototype, "setContains", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], FilterStore.prototype, "setOpen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FilterStore.prototype, "setAferDate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FilterStore.prototype, "setBeforeDate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], FilterStore.prototype, "setFilterActive", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], FilterStore.prototype, "setSelGroupids", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FilterStore.prototype, "reset", null);
